const tours = {
  tour: "การท่องเที่ยว", // translated
  tours: "ทัวร์", // translated
  addOn: "เพิ่มเข้าไป", // translated
  addOns: "ส่วนเสริม", // translated
  availableEscapes: "การหลบหนีที่มีอยู่", // translated
  availableExperiences: "ประสบการณ์ที่มีอยู่", // translated
  getRequest: "รับคำขอ", // translated
  sendRequest: "ส่งคำขอ", // translated
  selectRoom: "เลือกห้อง", // translated
};


export default tours;
